import React, { useState, useEffect, useRef } from "react";
import * as S from "./styles";
import { Link } from "react-router-dom";
import * as API from "../../api";
import {
  DELAY_BUSCADOR_DATOSPRINEX,
  DATOSPRINEX_POR_PAGINA,
  TITULOS_COLUMNAS_DATOSPRINEX,
} from "../../constants";
import { Loading } from "../../components/Loading";
import { FilterRow } from "../../components/FilterRow";
import { Sort } from "../../components/Sort";

export const DatosPrinex = () => {
  const [loading, setLoading] = useState(true);
  const [loadingCount, setLoadingCount] = useState(true);
  const [datosPrinex, setDatosPrinex] = useState([]);
  const [pages, setPages] = useState(1);
  const [countDatosPrinex, setCountDatosPrinex] = useState(0);
  const [allShowed, setAllShowed] = useState(false);
  const [triggerSearch, setTriggerSearch] = useState(false);
  const [mainFilter, setMainFilter] = useState(
    "todos-los-datos-erp-expediente"
  );
  const [openedFilter, setOpenedFilter] = useState(false);
  const [selectableFilters, setSelectableFilters] = useState([]);
  const [filters, setFilters] = useState([{ FilterId: "", FilterValue: "" }]);
  const [sortActive, setSortActive] = useState({
    FieldId: TITULOS_COLUMNAS_DATOSPRINEX[0].key,
    Order: "asc",
  });
  const delayTimer = useRef();
  useEffect(() => {
    getCountDatosPrinex();
    getDatosPrinex();
    API.getSearchFilter("UB_datos_prinex")
      .then((res) => {
        initializationFilter(res);
        setSelectableFilters(res);
      })
      .catch((error) => API.DEVELOP && console.log(error));
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(() => {
    triggerSearch && handleFiltersChange();
  }, [triggerSearch]); // eslint-disable-line react-hooks/exhaustive-deps

  const initializationFilter = (selectableFilters) => {
    const FincasFilterId = selectableFilters.find(
      (filter) => filter.FilterName === "Id Activo"
    )?.FilterId;
    const filtros = [{ FilterId: FincasFilterId }];
    setFilters(filtros);
  };

  const pagination = (page) => {
    return { Page: page, PageSize: DATOSPRINEX_POR_PAGINA };
  };

  const getValidActiveFilters = () => {
    const activeFilters =
      mainFilter === "todos-los-datos-erp-expediente" ? [filters[0]] : filters;
    const validFilters = activeFilters.filter(
      (filter) => filter.FilterId && filter.FilterValue
    );
    return validFilters;
  };

  const getCountDatosPrinex = () => {
    setLoadingCount(true);
    let data = {};
    const validActiveFilters = getValidActiveFilters();
    if (validActiveFilters.length) data.Filters = validActiveFilters;

    API.getCountDatosPrinex(data)
      .then((res) => {
        setCountDatosPrinex(res?.count);
        setLoadingCount(false);
      })
      .catch((error) => API.DEVELOP && console.log(error));
  };

  const getDatosPrinex = (page = 1) => {
    setLoading(true);
    let data = {};
    data.Pagination = pagination(page);
    const validActiveFilters = getValidActiveFilters();
    if (validActiveFilters.length) data.Filters = validActiveFilters;
    data.Sort = sortActive;

    API.getDatosPrinex(data)
      .then((res) => {
        if (res) {
          if (page === 1 && res.length === 0) setDatosPrinex([]);
          if (res.length > 0) {
            if (page === 1) setDatosPrinex(res);
            else setDatosPrinex([...datosPrinex, ...res]);
          }
          if (res.length < DATOSPRINEX_POR_PAGINA) {
            setAllShowed(true);
          }
          setPages(page);
        }
        setLoading(false);
      })
      .catch((error) => API.DEVELOP && console.log(error));
  };

  const handleFiltersChange = () => {
    API.sourceGetCountDatosPrinex.cancel();
    API.sourceGetDatosPrinex.cancel();
    setAllShowed(false);
    clearTimeout(delayTimer.current);
    delayTimer.current = setTimeout(() => {
      getCountDatosPrinex();
      getDatosPrinex();
    }, DELAY_BUSCADOR_DATOSPRINEX);
    setTriggerSearch(false);
  };

  const showMore = () => getDatosPrinex(pages + 1);

  const showedDatosPrinex = allShowed
    ? countDatosPrinex
    : pages * DATOSPRINEX_POR_PAGINA;
  const totalDatosPrinex = loadingCount
    ? `${DATOSPRINEX_POR_PAGINA}+`
    : countDatosPrinex;

  const changeMainFilter = (e) => {
    const value = e.target.value;
    if (value === "todos-los-datos-erp-expediente") setOpenedFilter(false);
    if (value === "filtros") {
      if (filters.length === 1) addFilter();
      setOpenedFilter(true);
    }
    setMainFilter(value);

    const totalValidFilters = filters.filter(
      (filter) => filter.FilterId && filter.FilterValue
    ).length;
    const defaultsFilter = [filters[0]];
    const defaultsValidFilters = defaultsFilter.filter(
      (filter) => filter.FilterId && filter.FilterValue
    ).length;
    if (totalValidFilters !== defaultsValidFilters) setTriggerSearch(true);
  };

  const addFilter = () => {
    const filtros = [...filters];
    filtros.push({ FilterId: "", FilterValue: "" });
    setFilters(filtros);
  };

  const removeFilter = (id) => {
    const filtros = [...filters];
    if (filters.length === 2) {
      changeFieldFilter(1, "");
      setFilters(filtros);
    }
    if (filters.length > 2) {
      filtros.splice(id, 1);
      setFilters(filtros);
      if (filters[id].FilterValue !== "") setTriggerSearch(true);
    }
  };

  const changeFieldFilter = (id, value) => {
    const filtros = [...filters];
    filtros[id].FilterId = value;
    setFilters(filtros);
    if (filtros[id].FilterValue !== "") changeTextFilter(id, "");
  };

  const changeTextFilter = (id, value) => {
    const filtros = [...filters];
    filtros[id].FilterValue = value;
    setFilters(filtros);
    setTriggerSearch(true);
  };

  const sort = (field, value) => {
    setSortActive({
      FieldId: field,
      Order: value,
    });
    setTriggerSearch(true);
  };

  return (
    <S.Container>
      <Loading hidden={!loading} />
      <S.TitleBar>
        Datos ERP Expediente ({showedDatosPrinex} de {totalDatosPrinex})
      </S.TitleBar>
      <S.SearchBar>
        <S.SelectSearchBar onChange={changeMainFilter} value={mainFilter}>
          <option value="todos-los-datos-erp-expediente">
            Todos los Datos ERP Expediente
          </option>
          <option value="filtros">Filtros</option>
        </S.SelectSearchBar>
        {mainFilter === "filtros" && (
          <S.ButtonSearchBar onClick={() => setOpenedFilter(!openedFilter)}>
            Filtros 👁
          </S.ButtonSearchBar>
        )}
        <S.InputSearchBar
          id="searchField"
          placeholder="Buscar por dato ERP expediente..."
          value={filters[0].FilterValue || ""}
          onChange={(e) => changeTextFilter(0, e.target.value)}
        />
      </S.SearchBar>
      <S.FilterBars hidden={!openedFilter}>
        {filters.map(
          (filter, index) =>
            index > 0 && (
              <FilterRow
                key={index}
                id={index}
                filter={filter}
                selectableFilters={selectableFilters}
                addFilter={addFilter}
                removeFilter={removeFilter}
                changeFieldFilter={changeFieldFilter}
                changeTextFilter={changeTextFilter}
              />
            )
        )}
      </S.FilterBars>
      <S.Table>
        <thead>
          <tr>
            {TITULOS_COLUMNAS_DATOSPRINEX.map((titulo) => (
              <S.TdThead
                key={titulo.key}
                className={titulo.key === sortActive.FieldId ? "active" : null}
              >
                <S.HeaderColumn>
                  <span>{titulo.label}</span>
                  {titulo.sortable && (
                    <Sort
                      field={titulo.key}
                      sortActive={sortActive}
                      onClick={(value) => sort(titulo.key, value)}
                    />
                  )}
                </S.HeaderColumn>
              </S.TdThead>
            ))}
          </tr>
        </thead>
        <tbody>
          {datosPrinex.length > 0 &&
            datosPrinex.map((datoPrinex) => (
              <tr key={datoPrinex.Id}>
                <td>
                  <Link to={"/UB_datos_prinex/" + datoPrinex.Id}>
                    {datoPrinex.Name}
                  </Link>
                </td>
                <td>{datoPrinex.Promocion}</td>
                <td>{datoPrinex.ValorContableBruto}</td>
                <td>{datoPrinex.ValorContableNeto}</td>
                <td>{datoPrinex.IdPrinex}</td>
                <td>{datoPrinex.ValorAdjudicacion}</td>
                <td>{datoPrinex.Propietario}</td>
              </tr>
            ))}
        </tbody>
      </S.Table>
      <S.Pagination>
        <S.More onClick={showMore} disabled={loading || allShowed}>
          {allShowed
            ? "No hay más datos ERP expediente"
            : "Más Datos ERP expediente..."}
        </S.More>
      </S.Pagination>
    </S.Container>
  );
};
